<div
  class="flex h-full flex-col items-center justify-between gap-4 rounded-4xl border-2 border-background-white bg-background-modal p-6 shadow-modal backdrop-blur-modal"
>
  <div class="relative flex w-full justify-center">
    @if (data.id) {
      <mat-menu #downloadMenu="matMenu">
        <button class="flex justify-between gap-4 font-medium text-text-primary" (click)="onDownloadAttachmentsClick()">
          <span>{{ 'collab_message_context_download' | translate }}</span>
          <svg-icon class="shrink-0" size="md" key="px-24-download"></svg-icon>
        </button>
      </mat-menu>
      <button class="absolute left-3 top-0" [matMenuTriggerFor]="downloadMenu" (click)="onDownloadButtonClick()">
        <svg-icon class="text-text-blue" key="px-24-download" size="md"></svg-icon>
      </button>
    }
    <span class="typo-h2 text-text-primary">&nbsp;</span>
    <button class="absolute right-0 top-0" (click)="onCloseClick()">
      <svg-icon class="text-text-primary" key="px-16-x" size="sm"></svg-icon>
    </button>
  </div>
  @if (attachmentIsImage(data) && data.fileData.imageUrl; as imageUrl) {
    <div class="flex flex-grow items-center overflow-hidden">
      <img class="max-h-[100%] w-auto rounded-[32px]" crossorigin="anonymous" [src]="imageUrl" />
    </div>
  } @else if (attachmentIsVideo(data)) {
    <div class="flex w-full flex-grow items-center justify-center overflow-hidden">
      <lib-video-player
        class="!h-auto"
        [videoOptions]="{
          autoplay: data.autoplay ?? false,
          fileType: data.fileData.fileType!,
          videoUrl: data.fileData.videoUrl!,
          thumbnailUrl: data.fileData.thumbnailUrl!,
          loop: false
        }"
        (videoStarted)="onVideoStarted()"
        (videoFinished)="onVideoFinished()"
        (videoDisposed)="onVideoDisposed($event)"
      ></lib-video-player>
    </div>
  }
</div>
